import React, {useRef} from 'react';
import {Controller} from 'react-hook-form';
import {
    FormError,
    FormLabel,
    getInputClassNames,
    getInputWrapperClass,
    getWholeDivWrapperClass,
} from "./sharedStyles.tsx";
import {DateTimeComponent, FormComponentProps} from "../DynamicFormTypes.ts";
import {useFormMethods} from "../DyanmicFormContext.tsx";
import {useFieldBlurHandler} from "../hooks/OnFieldBlurHanlder.tsx";
import {useValidationRules} from "../hooks/useValidationRules.tsx";

const DateTimeRenderer: React.FC<FormComponentProps<DateTimeComponent>> = ({ component }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const { formMethods } = useFormMethods()
    const validate = useValidationRules({ component });

    // Handle click on the wrapper div to focus the input
    const handleWrapperClick = () => {
        if (inputRef.current) {
            inputRef.current.showPicker();
        }
    };

    const { handleFieldBlur } = useFieldBlurHandler({
        component
    });

    return (
        <Controller
            name={component.fieldKey}
            control={formMethods.control}
            rules={validate}
            render={({ field: { ref, onBlur, ...fieldProps }, fieldState }) => (
                <div className={getWholeDivWrapperClass(component)}>
                    <FormLabel component={component} />

                    <div className={getInputWrapperClass(component) + " cursor-pointer"} onClick={handleWrapperClick}>
                        <input
                            id={component.fieldKey}
                            type="datetime-local"
                            className={getInputClassNames(component, fieldState)}
                            ref={inputRef}
                            {...fieldProps}
                            value={fieldProps.value || ''}
                            onBlur={(_e) => {
                                onBlur()
                                handleFieldBlur();
                            }}
                        />
                    </div>

                    <FormError fieldState={fieldState} component={component} />
                </div>
            )}
        />
    );
}

export const DateTime = React.memo(DateTimeRenderer);

